module.exports = __webpack_public_path__ + "static/media/personWebApp.259cf7ed.png";